import { connect } from 'react-redux';
import LanguageSelector from "./LanguageSelector";
import {
    getTranslationsList
} from "../../reducers/common/localization";

const mapStateToProps = state => {
    return {
        languageList: getTranslationsList(state)
    };
};

export default connect(mapStateToProps)(LanguageSelector);



// WEBPACK FOOTER //
// ./src/components/languageSelector/NotificationsLanguageSelector.container.js